import Lity from "lity";
import Zoomist from "zoomist";

export default class ImageZoomer {
  setGeneralEvent(rootElement = document) {
    this._setEvent("[data-lightbox]", "href", rootElement);
  }

  setCKEditorEvent(rootElement = document) {
    if (!rootElement) return;

    // リンクが設定されていない画像のみが対象
    this._setEvent(":not(a) > img", "src", rootElement);
    this._setEvent("a[href=''] > img", "src", rootElement);
  }

  _setEvent(selectors, image_path_attribute, rootElement) {
    const template = `
      <div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1">
        <div class="lity-wrap" data-lity-close role="document">
          <div class="lity-loader" aria-hidden="true">Loading...</div>
          <div class="lity-container">
            <div class="zoomist-container">
              <!-- zoomist-wrapper is required -->
              <div class="zoomist-wrapper">
                <!-- zoomist-image is required -->
                <div class="zoomist-image lity-content">
                  <!-- you can add anything you want to zoom here. -->
                </div>
              </div>
            </div>
            <button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button>
          </div>
        </div>
      </div>
    `;

    rootElement.querySelectorAll(selectors).forEach((element) => {
      // CKEditorで埋め込んだ画像(imgタグ)がクリッカブルであることがわかるようカーソル変更
      element.style.cursor = "pointer";

      element.addEventListener('click', (e) => {
        e.preventDefault();

        const instance = Lity(
          element.getAttribute(image_path_attribute),
          { template },
          'click'
        );
        instance.element().on('lity:ready', (event) => {
          new Zoomist(event.currentTarget.querySelector('.zoomist-container'), {
            maxScale: 5,
            slider: true,
            zoomer: true,
          });
        });
      });
    });
  }
}
